import { useSubmitTheoryAnswersMutation } from '@/types/vue-apollo-helpers';

/**
 * Saves theory / fill-in answers during an exam. This runs on every auto-save, so it
 * shows no toasts of its own and registers no onError listener: with none registered,
 * `mutate` rejects on failure, which lets the exam page re-queue the answers for retry
 * instead of silently dropping them.
 */
export function useSubmitTheoryAnswers() {
  const {
    mutate: submitTheoryAnswers,
    loading,
    error,
    onDone,
    onError,
  } = useSubmitTheoryAnswersMutation();

  return {
    submitTheoryAnswers,
    loading,
    error,
    onDone,
    onError,
  };
}
